import { render } from "./ButtonBistro.vue?vue&type=template&id=4d29bf50"
import script from "./ButtonBistro.vue?vue&type=script&lang=js"
export * from "./ButtonBistro.vue?vue&type=script&lang=js"

import "./ButtonBistro.vue?vue&type=style&index=0&id=4d29bf50&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__